<div class="body ui" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="top">
    <div
      fxLayoutAlign="start center"
      fxLayout="row"
      fxLayoutGap="20px"
      (click)="goBack()"
      class="link"
    >
      <div>
        <img src="assets/icons/left-arrow-icon.svg" alt="" />
      </div>
      <div class="equipment-id">
        <div class="ui breadcrumb">
          <div class="section ash">Home</div>
          <div class="divider">/</div>
          <div class="section ash">Settings</div>
        </div>
        <h2 class="ui primary header fw-bold">Manage Workflow</h2>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="15px">
      <button
        *isPermitted="{ id: 'WORKFLOW_MANAGEMENT', action: 'add' }"
        class="ui small button primary"
        (click)="newWorkflow()"
      >
        Create New Workflow
      </button>
    </div>
  </div>

  <div class="ui divider" appMargin marginY="3"></div>

  <div class="ui grid">
    <div class="five wide column" style="padding-right: 0">
      <!--<div style="margin-top: 40px; margin-bottom: 10px">Department Unit</div>
       <div class="side-panel">
        <a
          *ngFor="let unit of units"
          class="ui white button"
          fxLayout="row"
          (click)="selectUnit(unit)"
          [ngClass]="{ primary: selectedUnitId === unit.organizationUnitId }"
          appMargin
          marginY="8px"
          appPadding
          paddingY="14px"
        >
          {{ unit.unitName }}
        </a>
        <a
          *ngIf="(units && units.length < 1) || !units"
          class="ui primary button"
          fxLayout="row"
          appMargin
          marginY="8px"
          appPadding
          paddingY="14px"
        >
          No Department Unit
        </a>
      </div> -->

      <div class="side-panel">
        <a
          *ngFor="let worfklow of workflowTypes"
          class="ui white button"
          fxLayout="row"
          (click)="selectWorkflowType(worfklow.optionId, worfklow.optionName)"
          [ngClass]="{ primary: selectedWorkflowTypeId === worfklow.optionId }"
          appMargin
          marginY="8px"
          appPadding
          paddingY="14px"
          style="padding: 0.78571429em 0.8em 0.78571429em !important"
        >
          <p>{{ worfklow.optionName }}</p>
        </a>
      </div>
    </div>
    <div class="eleven wide column">
      <!-- <div
        class="ui segment"
        style="border-radius: 4px; border: none"
        appMargin
        marginT="0"
        appPadding
        paddingX="0px"
      > -->
      <app-search-filter
        [filter]="filter"
        (onSearch)="searchRecords($event)"
        (onDisplayRows)="displayRecords($event)"
        (onSort)="sortRecords($event)"
      ></app-search-filter>
      <!-- </div> -->

      <div class="ui vertical basic segment" [ngClass]="{ loading: pending || pendingArr.length }">
        <div
          fxLayout="row"
          tamsyMargin
          class="ui segment"
          marginB="3"
          fxLayoutGap="10px"
          fxLayoutAlign="start stretch"
          id="dark"
        >
          <div fxFlex="5%"></div>
          <div fxFlex="28%">Description</div>
          <div fxFlex="15%">Type</div>
          <div fxFlex="10%">Status</div>
          <div fxFlex="15%">Added By</div>
          <div fxFlex="15%">Date Created</div>
          <div fxFlex="15%"></div>
        </div>
        <app-no-record-found
          *ngIf="workflows && workflows.length < 1"
        ></app-no-record-found>
        <app-no-record-found *ngIf="!workflows"></app-no-record-found>

        <app-workflow-row
          *ngFor="let workflow of workflows"
          [activate]="false"
          [workflow]="workflow"
          (updateWorkflow)="updateWorkflow($event)"
          (activateWorkflow)="activateWorkflowModal($event)"
          (deActivateWorkflow)="deActivateWorkflowModal($event)"
        >
        </app-workflow-row>

        <div class="ui vertical basic segment">
          <div class="ui two column grid">
            <div class="column middle aligned">
              <div class="ui medium labeled button">
                <div class="ui icon button" (click)="getOrganizations()">
                  <i class="refresh icon"></i>
                </div>
                <a class="ui basic label"> {{ totalItems }} Record(s) </a>
              </div>
            </div>
            <div
              class="column right aligned pagination menu"
              style="margin-left: auto"
            >
              <sui-pagination
                class="small"
                [collectionSize]="totalItems"
                [pageSize]="rows"
                [maxSize]="maxSize"
                [hasEllipses]="true"
                [page]="currentPage"
                (pageChange)="nextPage($event)"
              >
              </sui-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
